var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconEyeVisible(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Core / Eye Visible") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Core-/-Eye-Visible",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.041,18.834 C20.751,20.905 18.316,22 16,22 C13.684,22 11.249,20.905 8.959,18.834 C7.726,17.719 6.841,16.601 6.402,16 C6.839,15.403 7.725,14.284 8.959,13.167 C9.41,12.759 9.867,12.4 10.327,12.069 C10.119,12.679 10,13.33 10,14.011 C10,17.324 12.687,20.011 16,20.011 C19.314,20.011 22,17.324 22,14.011 C22,13.33 21.881,12.679 21.673,12.068 C22.133,12.4 22.59,12.759 23.041,13.167 C24.274,14.283 25.159,15.4 25.598,16.001 C25.161,16.597 24.275,17.717 23.041,18.834 Z M14.736,12.211 C14.736,13.039 14.064,13.711 13.236,13.711 C12.407,13.711 11.736,13.039 11.736,12.211 C11.736,11.383 12.407,10.711 13.236,10.711 C14.064,10.711 14.736,11.383 14.736,12.211 Z M24.383,11.684 C21.719,9.273 18.82,8 16,8 C13.18,8 10.281,9.273 7.617,11.684 C6.61170026,12.5929564 5.67681535,13.637781 4.81234528,14.8184738 L4.81232814,14.8184613 C4.29726101,15.5219397 4.29726037,16.4780214 4.81232654,17.1815006 C5.67680184,18.3622039 6.61169299,19.407037 7.617,20.316 C10.281,22.727 13.18,24 16,24 C18.82,24 21.719,22.727 24.383,20.316 C25.3882997,19.4070436 26.3231846,18.362219 27.1876547,17.1815262 L27.1876719,17.1815387 C27.702739,16.4780603 27.7027396,15.5219786 27.1876735,14.8184994 C26.3231982,13.6377961 25.388307,12.592963 24.383,11.684 Z",
    id: "Fill-1",
    fill: "#42484D",
    fillRule: "nonzero"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEyeVisible);
export default __webpack_public_path__ + "static/media/icon-Eye-Visible.5568223d.svg";
export { ForwardRef as ReactComponent };